import React from "react";
import Modal from "../../../../elements/Modal";
import ManagePartner from "../ManagePartner";

const ManagePartnerModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="lg"
      title={data?._id ? "Update" : "Create New "}
    >
      <ManagePartner getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManagePartnerModal;
